import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SORT_KEYS } from "../state/searchUrlState";

const SortSelect = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  // Dentro del componente porque las etiquetas necesitan t(); si viviera fuera (módulo), no
  // tendría acceso al hook de traducción.
  const OPTIONS = [
    { value: SORT_KEYS.RECENT, label: t("search.buscar.sortRecent") },
    { value: SORT_KEYS.OLDEST, label: t("search.buscar.sortOldest") },
    { value: SORT_KEYS.AZ, label: t("search.buscar.sortAz") },
  ];
  const current = OPTIONS.find((o) => o.value === value) || OPTIONS[0];

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  return (
    <div className="bq-sort" ref={ref}>
      <button type="button" className="bq-sort-trigger" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <span>{current.label}</span>
        <svg width="14" height="14" viewBox="0 0 24 24" className={`bq-icon bq-chevron${open ? " is-open" : ""}`} aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && (
        <ul className="bq-sort-options" role="listbox">
          {OPTIONS.map((o) => (
            <li key={o.value}>
              <button
                type="button"
                role="option"
                aria-selected={o.value === current.value}
                className={o.value === current.value ? "is-active" : ""}
                onClick={() => {
                  onChange(o.value);
                  setOpen(false);
                }}
              >
                {o.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SortSelect;
